"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newsletterApi = void 0;
const axios_1 = __importDefault(require("axios"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const error_types_1 = require("@epic-mw/error-types");
const url = () => {
    const appContext = window_or_global_1.default.appContext && window_or_global_1.default.appContext !== '/' ? window_or_global_1.default.appContext : '';
    if (!window_or_global_1.default.location.origin) {
        const port = window_or_global_1.default.location.port ? `:${window_or_global_1.default.location.port}` : '';
        window_or_global_1.default.location.origin = `${window_or_global_1.default.location.protocol}//${window_or_global_1.default.location.hostname}${port}`;
    }
    const origin = window_or_global_1.default.serverUrl ? window_or_global_1.default.serverUrl : window_or_global_1.default.location.origin + appContext;
    return {
        ORIGIN: `${origin}`,
        GET_SUBSCRIPTION_STATUS: `${origin}/api/get-subcription-status`,
        SIGN_UP_NEWS_LETTER: `${origin}/api/sign-up-news-letter`
    };
};
class NewsletterApi {
    async subscribeToNewsletter(params) {
        const api = url().SIGN_UP_NEWS_LETTER;
        try {
            const response = await axios_1.default.post(api, Object.assign({}, params));
            return response.data;
        }
        catch (err) {
            console.error('subscribeToNewsletter() failed to load', (0, error_types_1.isError)(err) && err.message);
            throw err;
        }
    }
    async getSubscriptionStatus() {
        const api = url().GET_SUBSCRIPTION_STATUS;
        try {
            const response = await axios_1.default.get(api);
            return response.data;
        }
        catch (err) {
            console.error('getSubscriptionStatus() failed to load', (0, error_types_1.isError)(err) && err.message);
            throw err;
        }
    }
}
exports.newsletterApi = new NewsletterApi();
//# sourceMappingURL=newsletter.api.js.map